import { Injectable, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { auth } from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import * as firebase from 'firebase/app';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { OappService } from '../oapp.service';
import { CurBaseService } from './curbase.service';
import { first, map, tap } from 'rxjs/operators';
import { GlobalService } from '../global.service';
import Dexie from 'dexie';
import { StorageService } from '../storage/storage.service';
import { AutoLogoutService } from '../auto-logout.service';
export interface User {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string;
  emailVerified: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnInit {

  public userData: any;
  public userInfo: any
  private _sessionId: string;
  public showLoader: boolean = false;

  constructor(public afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    public router: Router,
    public ngZone: NgZone,
    public toster: ToastrService,
    private cookieService: CookieService,
    private oapp: OappService,
    private curBaseService: CurBaseService,
    private storService: StorageService,
    private autlogoutService: AutoLogoutService,
    private globalS: GlobalService,
  ) {

    this.afAuth.authState.subscribe(user => {
      console.log(user);
      this.userData = user;
      localStorage.setItem('user', JSON.stringify(user))
      this.globalS.initData(user)
    });
  }

  ngOnInit(): void { }

  //sign in function
  SignIn(email, password, porNetsolin, nit?) {
    if (nit != undefined) {
      var consper = this.curBaseService.consultaCollectionWhereFb('personas', 'email', email, '==').subscribe((res: any) => {
        consper.unsubscribe(); //termina la subscripcion para que no genere bucle de actualizaciones de usuario
        if (res.length > 0) {
          var busqueda = res[0].propiedades.hasOwnProperty(nit.toString());
          if (busqueda == false) {
            this.toster.error('No se a registrado usuario con el nit: ', nit);
            return;
          } else {
            return this.afAuth.auth.signInWithEmailAndPassword(email, password)
              .then((result) => {
                consper.unsubscribe(); //termina la subscripcion para que no genere bucle de actualizaciones de usuario
                // if (result.user.emailVerified !== true) {
                //   this.SetUserData(result.user);
                //   this.SendVerificationMail();
                //   this.showLoader = true;
                // } else {
                //   this.showLoader = false;
                //   this.ngZone.run(() => {
                //     this.router.navigate(['/auth/login']);
                //   });
                // }
                if (porNetsolin) {
                  //Actualiza empresa en login, para permitidas en nit
                  var consperdos = this.curBaseService.consultaCollectionWhereFb('personas', 'email', email, '==').subscribe((res: any) => {
                    consperdos.unsubscribe(); //termina la subscripcion para que no genere bucle de actualizaciones de usuario
                    var netsolin_ini = JSON.parse(localStorage.getItem("netsolin_ini"));
                    var nit_inicio = nit != undefined ? nit : netsolin_ini.nit_principal;
                    this.curBaseService.actDocFb(res[0].tipoID + res[0].id, '/personas', { ultimaPropiedad: nit_inicio });
                    this.router.navigate(['/monitortercero/VPARTERCEROS/0']);
                    this.storService.initBD(); // Inicializa base de datos local Dexie
                    this.autlogoutService.inicializarTimeout(); // Inicializa servicio de autologout
                  });
                } else {
                  this.router.navigate(['/select-rol']);
                  this.storService.initBD(); // Inicializa base de datos local Dexie
                  this.autlogoutService.inicializarTimeout(); // Inicializa servicio de autologout
                }
              }).catch((error) => {
                this.toster.error('Email o Password incorrecto.');
              })
          }
        } else {
          this.toster.error('No se a registrado usuario');
        }
      });
    }
    else {
      return this.afAuth.auth.signInWithEmailAndPassword(email, password).catch((error) => {
        this.toster.error('Email o Password incorrecto.');
      })
    }
  }

  getAuthToken() {
    return new Promise((resolve) => {
      if (this.userData) {
        this.userData.getIdToken().then(token => {
          resolve(token)
        })
      }
      else {
        resolve("nodefinido")
      }
    })
  }

  //main verification function
  SendVerificationMail() {
    this.toster.error('Verifique su cuenta con email que se envio a su direccion de correo electronico.')
    return this.afAuth.auth.currentUser.sendEmailVerification()
      .then(() => {
        this.router.navigate(['/auth/login']);
      })
  }

  //Sign in with Facebook
  signInFacebok() {
    return this.AuthLogin(new auth.FacebookAuthProvider());
  }

  //Sign in with Twitter
  signInTwitter() {
    return this.AuthLogin(new auth.TwitterAuthProvider());
  }

  //Sign in with Google
  GoogleAuth() {
    return this.AuthLogin(new auth.GoogleAuthProvider());
  }

  ForgotPassword(passwordResetEmail) {
    return this.afAuth.auth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        window.alert('Password reset email sent, check your inbox.');
      }).catch((error) => {
        window.alert(error);
      });
  }

  //Authentication for Login
  AuthLogin(provider) {
    return this.afAuth.auth.signInWithPopup(provider)
      .then((result) => {
        this.ngZone.run(() => {
          this.router.navigate(['/dashboard/default']);
        });
        this.SetUserData(result.user);
      }).catch((error) => {
        window.alert(error);
      });
  }

  //Set user
  SetUserData(user) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const userData: User = {
      email: user.email,
      displayName: user.displayName,
      uid: user.uid,
      photoURL: user.photoURL || 'assets/dashboeard/boy-2.png',
      emailVerified: user.emailVerified
    };
    userRef.delete().then(function () { })
      .catch(function (error) { });
    return userRef.set(userData, {
      merge: true
    });
  }


  // Sign out
  SignOut() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    return this.afAuth.auth.signOut().then(() => {
      this.showLoader = false;
      localStorage.clear();
      Dexie.delete('NETSOLIN');
      this.cookieService.deleteAll('user', '/auth/login');
      this.router.navigate(['/auth/login']);
    });
  }

  SignOutTimeOut() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    return this.afAuth.auth.signOut().then(() => {
      this.showLoader = false;
      this.cookieService.deleteAll('user', '/auth/login');
      this.router.navigate(['/auth/login']);
    });
  }


  // Registro de usuario
  registerUser(email: string, password: string) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password)
  }

  isEmpty(obj) { return Object.keys(obj).length === 0; }

  mergeObj(...arr) {
    return arr.reduce((acc, val) => {
      return { ...acc, ...val };
    }, {});
  }


}
